/* ============================================================
   Desire Theme – Tabellen 1:1 wie Desktop, aber passend skaliert
   - passt Breite dynamisch an Container an (keine Umbrüche, kein H-Scroll)
   - funktioniert auch in Accordions (bei Öffnen neu berechnen)
   - entfernt leere, versehentlich angelegte 4. Spalten
   ============================================================ */
(function () {
  const SELECTOR = '.accordion-content .rte table, .collapsible__content .rte table, details .rte table, .rte table';

  function wrapTable(table) {
    const p = table.parentElement;
    if (p && p.classList && p.classList.contains('table-scale-wrap')) return p;
    const wrap = document.createElement('div');
    wrap.className = 'table-scale-wrap';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
    return wrap;
  }

  function pruneEmptyTrailingCells(table, keepCols = 3) {
    Array.from(table.rows).forEach(row => {
      let cells = Array.from(row.cells);
      while (cells.length > keepCols && cells[cells.length - 1].textContent.trim() === '') {
        row.deleteCell(cells.length - 1);
        cells = Array.from(row.cells);
      }
    });
  }

  function scaleTableToFit(table) {
    const wrap = wrapTable(table);
    table.style.transform = 'none';
    wrap.style.height = '';
    pruneEmptyTrailingCells(table, 3);
    // CSV überschreibt width:100% -> neutralisieren, sonst scale = 1
table.style.setProperty('width', 'auto', 'important');
table.style.setProperty('max-width', 'none', 'important');
table.style.setProperty('table-layout', 'auto', 'important');



    // Sichtbar? Wenn Accordion zu ist, kurz warten bis offen.
    const wrapWidth = wrap.clientWidth;
    const naturalWidth = table.scrollWidth;
    if (!wrapWidth || !naturalWidth) return;

    let scale = Math.min(1, wrapWidth / naturalWidth);
const offsetX = Math.max(0, (wrapWidth - naturalWidth * scale) / 2);
table.style.transform = `translateX(${offsetX}px) scale(${scale})`;


    const naturalHeight = table.offsetHeight; // unskaliert
    wrap.style.height = (naturalHeight * scale) + 'px';
    wrap.classList.add('ready');
  }

  function rescaleAll() {
    document.querySelectorAll(SELECTOR).forEach(scaleTableToFit);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else fn();
  }

  const debounce = (fn, d=120) => {
    let t; return (...a)=>{ clearTimeout(t); t=setTimeout(()=>fn(...a), d); };
  };

  onReady(() => {
    rescaleAll();
    window.addEventListener('resize', debounce(rescaleAll, 150));

    // Neu berechnen, wenn Accordions/Details geöffnet werden
    document.addEventListener('toggle', () => setTimeout(rescaleAll, 60), true);

    // Größenänderungen im Accordion-Inhalt beobachten
    const ro = new ResizeObserver(debounce(rescaleAll, 80));
    document.querySelectorAll('.accordion-content, .collapsible__content, details').forEach(el => ro.observe(el));
  });
})();
